/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing core services.
 * @preferred
 * @module CoreModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    ModuleWithProviders,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'ng/shared/shared.module';
import { DialogModule } from 'ng/modules/dialog/dialog.module';
import { LoaderModule } from 'ng/modules/loader/loader.module';

import {
    AviAlertComponent,
    AviAppLevelAlertsPortalComponent,
    AviFaultAlertModalComponent,
    TransitionProgressBarComponent,
} from './components';

import {
    AppLevelAlertsService,
    AviAlertService,
    CentralLicenseAlertsService,
    DevLoggerService,
    LocationService,
    MyAccountService,
    ObjectDiffService,
    TenantService,
} from './services';

import {
    AlertLevelColorPipe,
    AviDatePipe,
    I18nDatePipe,
    SiteStateColorPipe,
} from './pipes';

const coreComponents = [
    AviAlertComponent,
    AviAppLevelAlertsPortalComponent,
    AviFaultAlertModalComponent,
    TransitionProgressBarComponent,
];

const coreServices = [
    TenantService,
    DevLoggerService,
    AviAlertService,
    AppLevelAlertsService,
    CentralLicenseAlertsService,
    ObjectDiffService,
    LocationService,
    MyAccountService,
];

const corePipes = [
    AviDatePipe,
    I18nDatePipe,
    AlertLevelColorPipe,
    SiteStateColorPipe,
];

@NgModule({
    declarations: [
        ...coreComponents,
        ...corePipes,
    ],
    imports: [
        SharedModule,
        CommonModule,
        DialogModule,
        FormsModule,
        LoaderModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    exports: [
        ...corePipes,
        TransitionProgressBarComponent,
    ],
})
export class CoreModule {
    public static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                ...coreServices,
                ...corePipes,
            ],
        };
    }
}
